export const GET_SOURCE_SETTINGS_STICKY_COLUMNS = "GET_SOURCE_SETTINGS_STICKY_COLUMNS";
export const GET_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS = "GET_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS";
export const GET_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR = "GET_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR";

export const UPDATE_SOURCE_SETTING_STICKY_COLUMNS = "UPDATE_SOURCE_SETTING_STICKY_COLUMNS";
export const UPDATE_SOURCE_SETTING_STICKY_COLUMNS_SUCCESS = "UPDATE_SOURCE_SETTING_STICKY_COLUMNS_SUCCESS";
export const UPDATE_SOURCE_SETTING_STICKY_COLUMNS_ERROR = "UPDATE_SOURCE_SETTING_STICKY_COLUMNS_ERROR";

export const GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS = "GET_LEAD_SOURCE_SETTING_STICKY_COLUMNS";
export const GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS = "GET_LEAD_SOURCE_SETTING_STICKY_COLUMNS_SUCCESS";
export const GET_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR = "GET_LEAD_SOURCE_SETTING_STICKY_COLUMNS_ERROR";

export const UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS = "UPDATE_LEAD_SOURCE_SETTING_STICKY_COLUMNS";
export const UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS = "UPDATE_LEAD_SOURCE_SETTING_STICKY_COLUMNS_SUCCESS";
export const UPDATE_LEAD_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR = "UPDATE_LEAD_SOURCE_SETTING_STICKY_COLUMNS";

export const GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS = "GET_CALL_SOURCE_SETTING_STICKY_COLUMNS";
export const GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS = "GET_CALL_SOURCE_SETTING_STICKY_COLUMNS_SUCCESS";
export const GET_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR = "GET_CALL_SOURCE_SETTING_STICKY_COLUMNS_ERROR";

export const UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS = "UPDATE_CALL_SOURCE_SETTING_STICKY_COLUMNS";
export const UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_SUCCESS = "UPDATE_CALL_SOURCE_SETTING_STICKY_COLUMNS_SUCCESS";
export const UPDATE_CALL_SOURCE_SETTINGS_STICKY_COLUMNS_ERROR = "UPDATE_CALL_SOURCE_SETTING_STICKY_COLUMNS_ERROR";
